import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import AppContainer from './src/components/AppContainer';
import configureStore from './src/redux/store';
import { initNewRelic } from './src/new-relic';
import { injectLoggerIntoGlobal } from './src/providers/logger/injectLoggerIntoGlobal';

initNewRelic();
injectLoggerIntoGlobal();

const store = configureStore({});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <AppContainer />
    </BrowserRouter>
  </Provider>,
  document.getElementById('app'),
);
